import { useState } from "react";

import Dropdown from "react-bootstrap/lib/Dropdown";
import MenuItem from "react-bootstrap/lib/MenuItem";
import DropdownMenu from "react-bootstrap/lib/DropdownMenu";
import DropdownToggle from "react-bootstrap/lib/DropdownToggle";

interface DropdownProps {
  id?: string;
  initValue?: number;
  customClass?: string;
  onChange: Function;
  placeHolder: string;
  options: Array<any>;
  renderLabel: Function;
}

const BsDropdown = ({
  id = "custom-dropdown",
  initValue = 0,
  onChange = () => {},
  placeHolder = "",
  options = [],
  customClass = "",
  renderLabel,
}: DropdownProps) => {
  const [value, setValue] = useState(initValue);

  const onSelect = (idx) => {
    const selectedVal = options[idx];
    setValue(idx);
    onChange(selectedVal);
  };

  const selectedOption = options[value];

  const hasRenderLabel = typeof renderLabel === "function";
  const headValue = hasRenderLabel
    ? renderLabel({ active: true, option: selectedOption })
    : selectedOption?.label || placeHolder;

  return (
    <Dropdown id={id} onSelect={onSelect} className={customClass}>
      <DropdownToggle>{headValue}</DropdownToggle>
      <DropdownMenu>
        {options.map((option, idx) => {
          const { label } = option;
          const props = {
            active: idx == value,
            eventKey: idx,
            option,
          };
          return (
            <MenuItem key={`dropdown-item-${idx}`} {...props}>
              {hasRenderLabel ? renderLabel(props) : label}
            </MenuItem>
          );
        })}
      </DropdownMenu>
    </Dropdown>
  );
};

export default BsDropdown;
